<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Settings') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="settings-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="settings-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="outer-container">
        <div class="row">
          <div class="col-xl-3 col-md-4">
            <currency-select-input-widget :key="`branch-currency-${model.uuid}`" :model="model"
                                          attribute="currency_uuid"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <percentage-input-widget :model="model" attribute="tax_rate" step="any"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="decimal_separator" type="select2" value-field="value"
                          display-field="${item.key}" :items="decimalSeparators"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="thousand_separator" type="select2" value-field="value"
                          display-field="${item.key}" :items="thousandSeparators"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="date_format" value-field="value" display-field="${item.key}"
                          type="select2" :items="dateFormats"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="time_format" value-field="value" display-field="${item.key}"
                          type="select2" :items="timeFormats"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="number_padding_prefixes"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="invoice_prefix"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="settlement_prefix"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="receipt_prefix"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="transfer_note_prefix"/>
          </div>
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="batch_payment_prefix"/>
          </div>
<!--          <div class="col-xl-3 col-md-4">-->
<!--            <input-widget :model="model" attribute="two_factor_auth_type" value-field="value"-->
<!--                          display-field="${item.key}" type="select2" :items="twoFactorAuthTypes"/>-->
<!--          </div>-->
          <div class="col-xl-3 col-md-4">
            <input-widget :model="model" attribute="auctioneers_sheet_prefix"/>
          </div>
          <div class="col-6">
            <input-widget :model="model" attribute="allow_webapp_condition_report_request" value-field="value"
                          display-field="${item.key}" type="select2" :items="allowWebappConditionReportRequests"/>
          </div>
          <div class="col-xl-3 col-md-5 mt-xl-4 mt-md-0">
            <input-widget is-switch :model="model" attribute="remove_decimals_on_zero" type="checkbox"/>
          </div>
          <div class="col-xl-3 col-md-5 mt-xl-4 mt-md-0">
            <input-widget is-switch :model="model" attribute="enable_estimate_request" type="checkbox"/>
          </div>
          <div class="col-xl-3 col-md-5 mt-xl-4 mt-md-0">
            <input-widget is-switch :model="model" attribute="auto_approve_invoices" type="checkbox"/>
          </div>
          <div class="col-xl-3 col-md-5 mt-xl-4 mt-md-0">
            <input-widget is-switch :model="model" attribute="auto_approve_settlements" type="checkbox"/>
          </div>
        </div>
        <div class="mb-2">
          {{ $t('Branch Logo') }}
        </div>
        <div class="row">
          <div class="col-md-8 col-sm-12 col-lg-6">
            <file-uploader :show-preview="false" @onItemsAdd="onLogoChange" @onItemRemove="onItemRemove"
                           :with-tooltip="false"
                           :items-prop="files" :text="$t('Drag your logo here')" :button-text="$t('Select Logo')"
                           :hint-text="false" :multiple="false" :uploading-progress="uploadingProgress"
                           :uploading-progress-value="uploadingProgressValue" :accept="fileUploaderAccept"
                           ref="fileUploader"/>
          </div>
        </div>
        <no-data-available :height="5" v-if="!selectedBranch"/>
      </div>
    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../../../../core/components/input-widget/InputWidget";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import PercentageInputWidget from "../../../../core/widgets/PercentageInputWidget";
  import FileUploader from "@/core/components/file-uploader/FileUploader";
  import CurrencySelectInputWidget from "@/core/widgets/CurrencySelectInputWidget";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "Settings",
    components: {CurrencySelectInputWidget, PercentageInputWidget, NoDataAvailable, InputWidget, FileUploader},
    data() {
      return {
        decimalSeparators: [
          {key: 'Dot (.)', value: '.'},
          {key: 'Comma (,)', value: ','}
        ],
        thousandSeparators: [
          {key: 'Dot (.)', value: '.'},
          {key: 'Comma (,)', value: ','},
          {key: "Apostrophe (')", value: "'"},
          {key: "Empty Space ( )", value: " "},
        ],
        uploadingProgressValue: 0,
        uploadingProgress: false,
        files: []
      };
    },
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    watch: {
      selectedBranch() {
        this.files = this.selectedBranch.logo ? [this.selectedBranch.logo] : [];
      }
    },
    computed: {
      ...mapState(['selectedBranch']),
      ...mapStateGlobal(['currencies', 'dateFormats', 'timeFormats', 'imageFileFormats', 'attachmentMaxFileSize', 'allowWebappConditionReportRequests']),
      fileUploaderAccept() {
        return [{formats: this.imageFileFormats, size: this.attachmentMaxFileSize}]
      },
    },
    methods: {
      ...mapActions(['updateSelectedBranchLogo']),
      async onLogoChange() {
        if (this.files.length > 1) {
          this.$errorDialog(this.$i18n.t('Only single file is allowed'), this.$i18n.t('Branch Logo'));
          await this.onItemRemove();
        } else {
          await this.updateSelectedBranchLogo(this.files[0])
        }
      },
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      async onItemRemove() {
        await this.updateSelectedBranchLogo(null);
        this.files = [];
        this.$refs.fileUploader.clearInput();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
